import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Layout/Header";
import AdminSidebar from "./Layout/Sidebar";
import Footer from "../common/Layout/Footer";
import TitleHeader from "../common/TitleHeader";
import ChatSupport from "../common/chatbot/ChatSupport";
import { getCurrentUser } from "./services/authService";
import Container from "apollo-react/components/Container";

import CommonBreadcrumbs, { pageIcons, getPageName } from "../common/CommonBreadcrumbs";
import axiosInstance from "../../axiosInstance";

const Layout = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").map(x => decodeURIComponent(x)).filter((x) => x);
  const [size, setSize] = useState([0, 0]);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [pageName, setPageName] = useState(getPageName("admin", location)); 

  // const iconStyles = { fontSize: "36px", color: "#4D4D4D" };
  // const pages = [
  //   { name: "home", icon: <HouseIcon style={{ ...iconStyles }} /> },
  //   { name: "users", icon: <MedicalCard style={{ ...iconStyles }} /> },
  //   { name: "end-users", icon: <MedicalCard style={{ ...iconStyles }} /> },
  //   { name: "roles", icon: <MedicalCard style={{ ...iconStyles }} /> },
  //   { name: "categories", icon: <MedicalCard style={{ ...iconStyles }} /> },
  //   { name: "forms", icon: <Planner style={{ ...iconStyles }} /> },
  //   { name: "subforms", icon: <Planner style={{ ...iconStyles }} /> },
  //   { name: "workflows", icon: <PresentationHierarchyLight style={{ ...iconStyles }} /> },
  //   { name: "approvals", icon: <StatusCheck style={{ ...iconStyles }} /> },
  //   { name: "reminders", icon: <Bell style={{ ...iconStyles }} /> },
  //   { name: "logs", icon: <FileAccountPlan style={{ ...iconStyles }} /> },
  // ];

  useEffect(() => {
    const [width] = size;
    if (width < 850 && width !== 0) setIsSidebarCollapsed(true);
  }, [size]);

  useEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  
  useEffect(() => {
    const savedSidebarState = localStorage.getItem("isSidebarCollapsed") === "true";
    setIsSidebarCollapsed(savedSidebarState);
  }, []);

  const handleSidebarToggle = (collapsed) => {
    setIsSidebarCollapsed(collapsed);
    if (collapsed) {
      localStorage.setItem("isSidebarCollapsed", true);
    } else {
      localStorage.removeItem("isSidebarCollapsed");
    }
  };

  // const pageName = getPageName("admin", location);
  useEffect(() => {
    const updatePageName = async () => {
      const match = location.pathname.match(/^\/admin\/categories\/(\d+)/);
      if (match) {
        const categoryId = match[1];
        try {
          const response = await axiosInstance.get(`/api/categories/${categoryId}`);
          const categoryName = response.data.name;
          setPageName(`categories / ${categoryName}-users`);
        } catch (error) {
          console.error("Error fetching category name:", error);
          setPageName("categories/users");
        }
      } else {
        setPageName(getPageName("admin", location));
      }
    };
  
    updatePageName();
  }, [location]);

  // Find the route name for the current page
  const routeName = (() => {
    // Try to match the route from routesConfig
    const routes = require("../../routesConfig").adminRoutesConfig; // adjust for persona if needed
    const pathname = location.pathname;
    const matchedRoute = routes.find(route => {
      const routePattern = route.path.replace(/:[^/]+/g, "[^/]+");
      const regex = new RegExp(`^${routePattern}$`);
      return regex.test(pathname);
    });
    return matchedRoute ? matchedRoute.name || matchedRoute.title?.toLowerCase() : "";
  })();

  return (
    <div>
      <Container
        className="main-container"
        style={{
          marginLeft: isSidebarCollapsed ? "64px" : "320px",
          width: isSidebarCollapsed ? "100%" : "75%",
        }}
      >
        <Header />

        <AdminSidebar
          isSidebarCollapsed={isSidebarCollapsed}
          setIsSidebarCollapsed={handleSidebarToggle}
        />

        <main className="main-content">
          <CommonBreadcrumbs
            source="admin"
            pathnames={pathnames}
            location={location}
          />

          <TitleHeader
            title={pageName}
            icon={pageIcons[routeName] || null}
          />

          <Outlet />
        </main>

        <Footer />
      </Container>
      <ChatSupport getCurrentUser={getCurrentUser} />
    </div>
  );
};

export default Layout;
